import { Controller, useFormContext } from 'react-hook-form'

import { POST_GROUP_MAX } from '@/components/retail/cms/post-form-model'
import { ChipPicker } from '@/components/retail/group-form'
import { useShopGroups } from '@/hooks/use-shop-catalog-query'
import { m } from '@/lib/paraglide/messages'

/** Sản phẩm nhắc tới trong bài (nhóm sản phẩm, hiện cuối bài trên web). */
export function PostGroupsField() {
    const { control } = useFormContext()
    const groups = useShopGroups({}).data?.data ?? []
    const nameOf = (id: string) => groups.find((g) => g.id === id)?.name ?? id
    return (
        <Controller
            control={control}
            name="group_ids"
            render={({ field }) => {
                const ids = (field.value as string[]) ?? []
                return (
                    <ChipPicker
                        id="post-groups"
                        name="group_ids"
                        label={m.cmsPost_groups({
                            max: String(POST_GROUP_MAX),
                        })}
                        chips={ids.map((id) => ({ id, name: nameOf(id) }))}
                        options={groups
                            .filter((g) => !ids.includes(g.id))
                            .map((g) => ({ value: g.id, label: g.name }))}
                        disabled={ids.length >= POST_GROUP_MAX}
                        onAdd={(id) => field.onChange([...ids, id])}
                        onRemove={(id) =>
                            field.onChange(ids.filter((x) => x !== id))
                        }
                    />
                )
            }}
        />
    )
}
